/** media_server's "no id": sent bare from the database, brace-wrapped over the data channel. */
const NULL_UUID = '00000000-0000-0000-0000-000000000000';

const HEX_RADIX = 16;
// The `y` digit carries the RFC 4122 variant: its top two bits are 10.
const VARIANT_KEEP_BITS = 0x3;
const VARIANT_BITS = 0x8;

/** Whether an id names nothing: absent, or either spelling of the null UUID. */
export function isNullUuid(id: string | null | undefined): boolean {
    return !id || id === NULL_UUID || id === `{${NULL_UUID}}`;
}

/** A random v4 UUID. `crypto.randomUUID` exists only in secure contexts; plain HTTP falls back. */
export function uuid(): string {
    if (globalThis.crypto?.randomUUID) {
        return globalThis.crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const random = Math.floor(Math.random() * HEX_RADIX);
        const digit = char === 'x' ? random : (random & VARIANT_KEEP_BITS) | VARIANT_BITS;
        return digit.toString(HEX_RADIX);
    });
}
